import { Severity } from '@rygen/rygen-ui/model';

// TODO: Move this to rygen ui

export interface HumanReadableError {
  message: string;
  reasonCode: string;
  severity: Severity;
  isHumanReadableError: true;
}

export const isHumanReadableError = (e: unknown): e is HumanReadableError => {
  return !!e && (e as HumanReadableError).isHumanReadableError;
};
